import React, {Component} from 'react';
import PropTypes from 'prop-types';

import WebPage from './../common/WebPage.jsx';
import Work from './Work';
import Play from './Play';
import PlayScreen from './play/PlayScreen';

export class Freq extends Component {

    static propTypes = {
        params: PropTypes.object.isRequired,
        segments: PropTypes.array.isRequired,
    }

    state = {
        section: 'play',
        logo_ref: React.createRef()
    };

    element = null;

    componentDidMount() {
        const {params, segments} = this.props;
        console.log("params", params)
        console.log("segments", segments)
    }

    menu_select = section => {
        this.setState({section: section})
    }

    render() {
        const {section, logo_ref} = this.state;
        const {params} = this.props;
        if (params.screen === 'play') {
            return <PlayScreen />
        }

        const options = [
            {title: 'work', section: 'work', selectable: section !== 'work'},
            {title: 'play', section: 'play', selectable: section !== 'play'},
        ];
        const content = section === 'work' ? <Work /> : <Play />
        return <WebPage
            brand={"mike hall studio freq"}
            title={"freq"}
            blurb={"get your freq on"}
            content={content}
            on_menu_select={section => this.menu_select(section)}
            menu={options}
            logo_ref={logo_ref}
        />
    }
}

export default Freq;
